var _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_181",
    "data-name": "Group 181",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.786,
    height: 30.527,
    viewBox: "0 0 45.786 30.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 7.186,
    cy: 7.186,
    rx: 7.186,
    ry: 7.186,
    transform: "translate(8.521 9.287)",
    fill: "#d1efff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-543.477-97.5c1.116,0,1.1,0,1.11,1.137,0,.3-.057.415-.383.4-.538-.03-1.08-.017-1.62,0-.219.006-.291-.047-.3-.284C-544.72-97.5-544.729-97.5-543.477-97.5Z",
    transform: "translate(556.869 111.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-393.446-96.04c-1.116,0-1.105,0-1.111-1.137,0-.3.056-.415.382-.4.538.03,1.08.017,1.62,0,.219-.006.292.046.3.284C-392.2-96.04-392.194-96.04-393.446-96.04Z",
    transform: "translate(425.833 112.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-543.429-66.028c-1.153,0-1.138,0-1.147-1.151,0-.325.1-.4.4-.381.523.023,1.049.023,1.572,0,.282-.013.33.09.334.348C-542.258-66.028-542.25-66.028-543.429-66.028Z",
    transform: "translate(556.773 85.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-393.454-66.075c-1.122.033-1.107.033-1.124-1.095,0-.346.1-.425.423-.406a13.34,13.34,0,0,0,1.524,0c.31-.018.385.091.355.373-.04.374.161.891-.079,1.089S-393.076-66.075-393.454-66.075Z",
    transform: "translate(425.851 85.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-393.452-126.039c-1.113,0-1.1,0-1.109-1.14,0-.3.066-.411.386-.394.539.028,1.08.018,1.62,0,.223-.006.289.054.3.287C-392.208-126.039-392.2-126.039-393.452-126.039Z",
    transform: "translate(425.836 138.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-543.449-36.044c-1.125,0-1.11,0-1.126-1.124-.005-.341.09-.429.419-.41.523.029,1.049.022,1.572,0,.258-.01.308.079.313.32C-542.246-36.044-542.238-36.044-543.449-36.044Z",
    transform: "translate(556.773 59.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-393.442-36.046c-1.129,0-1.115,0-1.13-1.12,0-.334.077-.434.415-.415.538.031,1.08.017,1.62,0,.208-.005.3.056.264.267a.257.257,0,0,0,0,.048C-392.233-36.046-392.233-36.046-393.442-36.046Z",
    transform: "translate(425.847 59.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-543.446-126.04c-1.116,0-1.105,0-1.111-1.137,0-.3.056-.415.382-.4.538.03,1.08.018,1.62,0,.219-.006.292.046.3.284C-542.2-126.04-542.194-126.04-543.446-126.04Z",
    transform: "translate(556.757 138.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-594.729-187.95a3,3,0,0,0-2.4-2.883,9.835,9.835,0,0,0-2.186-.072,3.035,3.035,0,0,0-3.038,3.026c-.008.445,0,.891,0,1.335,0,.121.033.27-.154.294a5.049,5.049,0,0,0-1.371.542v-2.523c0-1.181,0-1.166-1.183-1.165-.321,0-.352.116-.349.383.014,1.017-.005,2.034.012,3.051,0,.3-.053.4-.38.4-1.526-.02-3.052-.016-4.578,0-.3,0-.4-.054-.4-.381q.017-8.392,0-16.784c0-.356.118-.4.429-.4,1.478.016,2.956.021,4.434,0,.381-.006.5.066.5.478-.019,3.56-.011,7.121-.011,10.681,0,1.064,0,1.049,1.089,1.068.339.006.45-.055.449-.429-.016-4.1-.01-8.2-.01-12.3,0-.768-.25-1.011-1.035-1.011-1.781,0-3.561-.019-5.34.013-.443.008-.511-.132-.5-.525.028-1.033.011-2.066.008-3.1,0-.708-.264-.964-.984-.967-.572,0-1.145-.021-1.715.008-.311.016-.375-.093-.357-.375.024-.363.014-.731,0-1.1a.749.749,0,0,0-.205-.593.749.749,0,0,0-.584-.229q-3.028-.015-6.056,0a.738.738,0,0,0-.565.216.739.739,0,0,0-.214.566c-.014.4-.019.8,0,1.192.013.252-.066.323-.317.316-.6-.018-1.208-.009-1.812,0-.654,0-.924.273-.928.926,0,1.081-.015,2.162.007,3.242.007.33-.071.422-.411.418-1.844-.019-3.687-.011-5.531-.008-.656,0-.93.272-.932.921,0,1.1,0,2.193,0,3.29,0,1.136,0,1.122,1.113,1.137.324,0,.43-.062.422-.408-.026-1.016,0-2.034-.016-3.051-.005-.284.053-.376.359-.373q2.313.027,4.625,0c.284,0,.372.054.371.359q-.016,8.416,0,16.832c0,.343-.127.373-.408.371-1.494-.011-2.988-.017-4.482,0-.358,0-.472-.069-.47-.456.017-3.53.01-7.057.01-10.585,0-1.214,0-1.207-1.209-1.182-.236,0-.334.047-.323.31.021.54.007,1.081.007,1.621v10.191a3.245,3.245,0,0,0-1.237-.556c-.256-.045-.3-.156-.293-.378.012-.462.014-.924,0-1.383a3.047,3.047,0,0,0-2.946-2.927c-.492-.014-.985-.006-1.478,0a3.051,3.051,0,0,0-3.2,3.2c0,1.86,0,3.719,0,5.579,0,.935.2,1.135,1.151,1.135h43.482c.1,0,.191,0,.286,0a.773.773,0,0,0,.635-.22.773.773,0,0,0,.223-.634C-594.718-183.881-594.706-185.916-594.729-187.95Zm-42.708,5.074c-.018.286-.076.365-.37.365-1.17,0-1.17.011-1.17-1.172V-185.4c0-.792-.005-1.586,0-2.38a1.533,1.533,0,0,1,.449-1.164,1.533,1.533,0,0,1,1.165-.445c.476,0,.952-.009,1.428,0a1.528,1.528,0,0,1,1.09.452,1.529,1.529,0,0,1,.444,1.094,1.969,1.969,0,0,0,0,.238,1.29,1.29,0,0,1-.984,1.675A3.214,3.214,0,0,0-637.437-182.876Zm5.652.368c-.615-.045-1.236-.011-1.855-.011-.634,0-1.27-.025-1.9.01-.372.02-.438-.132-.37-.434a3.539,3.539,0,0,1,.148-.548,2.245,2.245,0,0,1,2.538-1.308,2.135,2.135,0,0,1,1.861,1.77c.059.342.043.557-.419.523Zm6.159-.011h-1.526c-.779,0-1.557-.012-2.336.007-.272.006-.337-.076-.341-.342-.013-1.191-.022-1.191,1.155-1.191,1.271,0,2.543.011,3.814-.008.314,0,.391.083.389.391-.008,1.144,0,1.144-1.155,1.144Zm6.013-27.475q2,.015,4,0c.231,0,.295.064.291.292q-.02,1.239,0,2.479c0,.231-.066.3-.293.291-.667-.014-1.335,0-2,0s-1.335-.01-2,.005c-.231,0-.295-.064-.291-.293q.019-1.239,0-2.479c0-.229.064-.291.292-.289Zm3.533,23.267c-.018.651-.006,1.3-.006,1.954,0,.636-.011,1.272.005,1.907.007.253-.04.361-.33.353-.794-.021-1.589-.025-2.383,0-.319.011-.354-.109-.352-.38q.02-1.931,0-3.862c0-.253.04-.361.33-.353.794.021,1.589.025,2.383,0,.319-.009.36.11.352.382Zm3.309,4.217a9.872,9.872,0,0,0-1.429,0c-.293.016-.371-.066-.368-.363.016-1.573.009-3.146.007-4.717,0-.783-.243-1.028-1.018-1.029q-2.026,0-4.052,0c-.8,0-1.034.237-1.035,1.059,0,1.541-.015,3.082.01,4.623.006.372-.105.452-.448.429a9.882,9.882,0,0,0-1.429,0c-.375.031-.432-.106-.431-.447.012-4.067.008-8.135.008-12.2,0-4.036,0-8.071-.008-12.107,0-.347.066-.453.434-.445,1.1.023,1.1,0,1.1,1.1,0,1.011.184,1.2,1.184,1.2h5.291c.965,0,1.155-.195,1.155-1.179,0-.254.015-.509,0-.762s.033-.353.325-.357c1.206-.016,1.206-.028,1.206,1.188q0,11.75.01,23.5c0,.414-.084.552-.509.513Zm6.287-.01h-1.622c-.763,0-1.526-.009-2.288,0-.246,0-.356-.027-.36-.323-.016-1.209-.029-1.208,1.185-1.208,1.255,0,2.511.014,3.766-.009.346-.007.411.1.407.422-.014,1.115,0,1.115-1.088,1.115Zm6.784.011c-.632-.042-1.268-.011-1.9-.011-.666,0-1.333-.012-2,.006-.244.007-.313-.079-.274-.3a4.763,4.763,0,0,1,.1-.512,2.231,2.231,0,0,1,2.563-1.479,2.133,2.133,0,0,1,1.907,1.83c.042.312.02.493-.39.466Zm3.111,0c-.363-.033-.794.109-1.076-.045s-.108-.631-.2-.96a3.572,3.572,0,0,0-2.615-2.686c-.308-.086-.365-.2-.353-.474.018-.412-.007-.825.009-1.237a1.518,1.518,0,0,1,1.463-1.467c.539-.019,1.079-.017,1.616,0a1.509,1.509,0,0,1,1.487,1.492c.019.841,0,1.682,0,2.523,0,.825-.008,1.649.006,2.474.007.266-.02.413-.345.383Z",
    transform: "translate(640.502 211.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-488.974-150.769c0,.795,0,.795-.779.795-.747,0-.747,0-.747-.731,0-.795,0-.795.779-.795C-488.974-151.5-488.974-151.5-488.974-150.769Z",
    transform: "translate(509.575 159.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-465.7-151.5c.722,0,.722,0,.722.708,0,.818,0,.818-.8.818-.722,0-.722,0-.722-.708C-466.5-151.5-466.5-151.5-465.7-151.5Z",
    transform: "translate(488.627 159.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-440.974-102.778c0,.8,0,.8-.818.8-.708,0-.708,0-.708-.722,0-.8,0-.8.818-.8C-440.974-103.5-440.974-103.5-440.974-102.778Z",
    transform: "translate(467.679 117.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M-488.974-78.73c0,.756,0,.756-.77.756s-.756,0-.756-.77,0-.756.77-.756S-488.974-79.5-488.974-78.73Z",
    transform: "translate(509.575 96.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M-464.974-78.705c0,.731,0,.731-.747.731-.779,0-.779,0-.779-.794,0-.732,0-.732.747-.732C-464.974-79.5-464.974-79.5-464.974-78.705Z",
    transform: "translate(488.627 96.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M-440.974-78.708c0,.735,0,.735-.744.735-.782,0-.782,0-.782-.792,0-.735,0-.735.744-.735C-440.974-79.5-440.974-79.5-440.974-78.708Z",
    transform: "translate(467.679 96.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-488.975-54.781c0,.807,0,.807-.815.807-.711,0-.711,0-.711-.719,0-.807,0-.807.815-.807C-488.975-55.5-488.975-55.5-488.975-54.781Z",
    transform: "translate(509.575 75.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-464.975-54.693c0,.719,0,.719-.712.719-.815,0-.815,0-.815-.807,0-.719,0-.719.712-.719C-464.975-55.5-464.975-55.5-464.975-54.693Z",
    transform: "translate(488.627 75.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M-442.5-126.739c0-.761,0-.761.765-.761s.761,0,.761.765,0,.761-.765.761S-442.5-125.974-442.5-126.739Z",
    transform: "translate(467.679 138.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M-464.974-126.7c0,.726,0,.726-.753.726-.773,0-.773,0-.773-.753,0-.773,0-.773.753-.773C-464.974-127.5-464.974-127.5-464.974-126.7Z",
    transform: "translate(488.627 138.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M-489.774-101.974c-.726,0-.726,0-.726-.753,0-.773,0-.773.753-.773.773,0,.773,0,.773.753C-488.974-101.974-488.974-101.974-489.774-101.974Z",
    transform: "translate(509.575 117.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M-489.762-125.974c-.738,0-.738,0-.738-.741,0-.785,0-.785.788-.785.738,0,.738,0,.738.741C-488.974-125.974-488.974-125.974-489.762-125.974Z",
    transform: "translate(509.575 138.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M-440.975-150.724c0,.75,0,.75-.729.75-.8,0-.8,0-.8-.776,0-.75,0-.75.729-.75C-440.975-151.5-440.975-151.5-440.975-150.724Z",
    transform: "translate(467.68 159.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-465.739-101.974c-.761,0-.761,0-.761-.765s0-.761.765-.761.761,0,.761.765S-464.974-101.974-465.739-101.974Z",
    transform: "translate(488.627 117.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M-441.717-55.5c.744,0,.744,0,.744.735,0,.792,0,.792-.783.792-.743,0-.743,0-.743-.735C-442.5-55.5-442.5-55.5-441.717-55.5Z",
    transform: "translate(467.679 75.34)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel1);
export default __webpack_public_path__ + "static/media/hotel-1.ce242df02748e568e3efcefddd1436a6.svg";
export { ForwardRef as ReactComponent };